<script setup>
import TenantFaqForm from '@frontJs/components/forms/projectManagement/TenantFaqForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant, tenantFaq } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    tenantFaq: {
        type: [Object, null],
        required: false,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="tenantFaq">
            Mettre à jour la FAQ #{{ tenantFaq.id }} - Gestion de projet -
            Datakepler
        </title>

        <title v-else>Créer une FAQ - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle v-if="tenantFaq" :tenant-name="tenant.name">
        Gestion de projet - Mettre à jour la FAQ #{{ tenantFaq.id }}
    </PageTitle>

    <PageTitle v-else :tenant-name="tenant.name">
        Gestion de projet - Créer une FAQ
    </PageTitle>

    <TenantFaqForm :tenant="tenant" :tenant-faq="tenantFaq" />
</template>
